<template>
  <div id="app">
    <transition name="fade">
    <!-- <keep-alive> -->
      <router-view></router-view>
    <!-- </keep-alive>  -->
   
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { detectZoom } from "./utils/utils";
import { BLACK_ROUTE_PATH } from "./page/commons/BoskTabNavigation/constant";
const lodash = require("lodash");
export default {
  name: "App",
  data() {
    return {
      blackRoutePath:[]
    };
  },
  computed: {
    ...mapGetters('tabNavigation',['currentNavigationList'])
  },
  created(){
    this.blackRoutePath=[...BLACK_ROUTE_PATH]
  },
  mounted() {
    window.onresize = () => {
      const m = detectZoom();
   
      // if (m > 125) {
      //   document.body.style.zoom = 100 / Number(m);
      // }
      // if (m < 100) {
      //   document.body.style.zoom = 1;
      // }
    };
  },
  watch: {
    $route: {
      handler(newArr, arr) {
        const { name, path } = newArr;
       
        BLACK_ROUTE_PATH.some((item) => item === path)
          ? this.setShowTabNavigation(false)
          : this.setShowTabNavigation(true);
        this.addNavigation({ name, path });
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations("tabNavigation", ["addNavigation", "setShowTabNavigation"]),
    onComponentActivated(component) {
      console.log("App Component activated:", component);
    },
  },
};
</script>

<style>
/* @media all and (-moz-min-device-pixel-ratio: 1.09) and (-moz-max-device-pixel-ratio: 1.18),
  (-webkit-min-device-pixel-ratio: 1.09) and (-webkit-max-device-pixel-ratio: 1.18),
  (min-resolution: 1.09dppx) and (max-resolution: 1.18dppx) {
  #app{
    font-size: 14px;
  }
}
@media all and (-moz-min-device-pixel-ratio: 1.19) and (-moz-max-device-pixel-ratio: 1.28),
  (-webkit-min-device-pixel-ratio: 1.19) and (-webkit-max-device-pixel-ratio: 1.28),
  (min-resolution: 1.19dppx) and (max-resolution: 1.28dppx) {
  #app {
    font-size: 13px;
  }
}
@media all and (-moz-min-device-pixel-ratio: 1.29) and (-moz-max-device-pixel-ratio: 1.4),
  (-webkit-min-device-pixel-ratio: 1.29) and (-webkit-max-device-pixel-ratio: 1.4),
  (min-resolution: 1.29dppx) and (max-resolution: 1.4dppx) {
  #app{
    font-size: 12px;
  }
}
@media all and (-moz-min-device-pixel-ratio: 1.41) and (-moz-max-device-pixel-ratio: 1.6),
  (-webkit-min-device-pixel-ratio: 1.41) and (-webkit-max-device-pixel-ratio: 1.6),
  (min-resolution: 1.41dppx) and (max-resolution: 1.6dppx) {
 #app {
    font-size: 10px;
  }
}
@media all and (-moz-min-device-pixel-ratio: 1.61) and (-moz-max-device-pixel-ratio: 1.8),
  (-webkit-min-device-pixel-ratio: 1.61) and (-webkit-max-device-pixel-ratio: 1.8),
  (min-resolution: 1.61dppx) and (max-resolution: 1.8dppx) {
   #app {
    font-size: 9px;
  }
}
@media all and (-moz-min-device-pixel-ratio: 1.81) and (-moz-max-device-pixel-ratio: 2.1),
  (-webkit-min-device-pixel-ratio: 1.81) and (-webkit-max-device-pixel-ratio: 2.1),
  (min-resolution: 1.81dppx) and (max-resolution: 2.1dppx) {
  #app {
    font-size: 8px;
  }
} */
#app {
  /*background:white;*/
  /* display:table-cell; */
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0.6;
}
</style>
